import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { EXPERIMENTS, useIsInExperimentVariation } from 'stash/components/experiments';
import { Navbar, SettingsNavBar } from 'stash/components/global';
import SettingsNavBarVariation from 'stash/components/global/SettingsNavBarVariation/SettingsNavBarVariation';
import { getEntitlementFlagsSelector, profileSelector, userSelector } from 'stash/selectors';
import { isMobileWeb, isNativeWebview } from 'stash/utils';
import DefaultAvatar from 'stash/assets/svg/default-avatar.svg';

export const GlobalHeader = () => {
    const location = useLocation();
    const user = useSelector(userSelector);
    const profile = useSelector(profileSelector);
    const entitlementFlags = useSelector(getEntitlementFlagsSelector);

    const isInStateZeroRedesignVariation = useIsInExperimentVariation(
        EXPERIMENTS.STATE_ZERO_REDESIGN,
        true
    );
    const isHeaderHiddenOnMobile = useIsInExperimentVariation(
        EXPERIMENTS.HIDE_HEADER_ON_MOBILE,
        true
    );

    // Determine if the settings header should be shown
    const isStateZeroRoute = location.pathname === '/sign-up/state-zero';
    const userIsBlockedFromStateZeroCheckpoint =
        entitlementFlags?.hasPersonalEnititlement &&
        !entitlementFlags?.hasSmartEntitlement &&
        (location.pathname === '/sign-up/state-zero-primer' ||
            location.pathname === '/sign-up/investment-selection');

    const shouldShowSettingsHeader = isStateZeroRoute || userIsBlockedFromStateZeroCheckpoint;

    // Render Settings Header if applicable
    if (shouldShowSettingsHeader) {
        const shouldShowMarketReport = entitlementFlags?.hasPremiumMarketReportEntitlement;

        return isInStateZeroRedesignVariation ? (
            <SettingsNavBarVariation
                user={user}
                showMarketReport={shouldShowMarketReport}
            />
        ) : (
            <SettingsNavBar
                user={user}
                avatar={profile?.avatar_url || DefaultAvatar}
                showMarketReport={shouldShowMarketReport}
            />
        );
    }

    // Otherwise, render the default Stash logo header
    const hideNavbar = isNativeWebview() || (isHeaderHiddenOnMobile && isMobileWeb());
    return (
        <>
            {!hideNavbar && <Navbar />}
        </>
    );
};
